var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import BusinessExternalService from '@dashboard/junk-drawer/clients/business-external-service';
import { Empty } from '@square/dashboard-protos/models/squareup/common/messages';
import { GetMerchantCategoriesResponse } from '@square/dashboard-protos/models/squareup/onboarding/business/common';
import { BusinessCategory } from '@square/dashboard-protos/models/squareup/onboard/business/categories';
import { BusinessSubcategory } from '@square/dashboard-protos/models/squareup/onboard/business/subcategories';
import * as Sentry from '@sentry/ember';
let MerchantCategories = (_class = class MerchantCategories extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "categories", _descriptor, this);
    _defineProperty(this, "setupPromise", void 0);
  }
  async getAndSetMerchantCategories() {
    try {
      this.categories = await BusinessExternalService.getMerchantCategories(Empty);
    } catch (e) {
      if (e.responseStatus === 404) {
        this.categories = GetMerchantCategoriesResponse.create({
          category: BusinessCategory.BUSINESS_CATEGORY_UNKNOWN,
          subcategory: BusinessSubcategory.BUSINESS_SUBCATEGORY_UNKNOWN
        });
      } else {
        Sentry.captureException(`Error loading merchant business categories: ${e}`);
      }
    }
    return this.categories;
  }
  async setup() {
    if (!this.setupPromise) {
      this.setupPromise = this.getAndSetMerchantCategories();
      const categories = await this.setupPromise;
      return categories;
    }
    return this.setupPromise;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "categories", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);
export { MerchantCategories as default };